import service from './request'
// 获取指标体系
export const indicatorsByGoalId = data => {
    return service({
        url: `/sdg/indicator/getIndicatorsByGoalId?goal=${data}`,
        method: 'get',
    })
}
// 根据指标获取系列
export const series = data => {
    return service({
        url: `/sdg/indicator/series?indicatorName=${data}`,
        method: 'get',
    })
}
// 根据系列 指标  国家获取图表数据
export const echarsDimension = data => {
    return service({
        url: `/sdg/indicator/dimension?indicatorName=${data.indicatorName}&geoCode=${data.geoCode}&seriesCode=${data.seriesCode}`,
        method: 'get',
    })
}

// 模糊查询国家
export const fuzzySearch = data => {
    return service({
        url: `/sdg/indicator/getCountryLikeArea?likeArea=${data.likeArea}&indicatorName=${data.indicatorName}&seriesCode=${data.seriesCode}`,
        method: 'get',
    })
}


// 根据国家名称字母获取对应国家
export const countryByAreaInitial = data => {
    return service({
        url: `/sdg/indicator/getCountryByAreaInitial?areaInitial=${data.areaInitial}&indicatorName=${data.indicatorName}&seriesCode=${data.seriesCode}`,
        method: 'get',
    })
}


// 获取国家列表
export const countryList = data => {
    return service({
        url: `/sdg/indicator/getCountryByArea?indicatorName=${data.indicatorName}&seriesCode=${data.seriesCode}`,
        method: 'get',
    })
}

// 数据与故事
export const stroyDataByGoalId = data => {
    return service({
        url: `/sdg/indicator/getStroyDataByGoalId?goal=${data.goal}`,
        method: 'get',
    })
}
